import {
	Component,
	ViewEncapsulation,
	Input,
	EventEmitter,
	Output,
	HostBinding,
	OnInit
} from "@angular/core";
import { IdService } from "../../shared/services/id.service";

@Component({
	selector: "rbc-media-card-footer",
	templateUrl: "./media-card-footer.component.html",
	encapsulation: ViewEncapsulation.None
})
export class MediaCardFooterComponent {
	@Input() id: string;
	@Input() linksAlignStart = false;
	@Input() card = false;
	@Input() index: number;
	@Input() article: Object;

	@Output() ctaLinkClicked = new EventEmitter();

	get classGen() {
		return {
			// "rbc-media-card-footer": !this.article.linkIcon && this.article.linkText && !this.article.footerAuthors,
			"rbc-media-card-footer-large": (this.article["footerAuthors"] && this.article["footerAuthors"].length) ||
				this.article["footerByline"] ||
				(this.article["footerLinks"] && this.article["footerLinks"].length),
			"rbc-media-card-footer-start": this.article["linkButton"] || this.linksAlignStart
		};
	}

	constructor(private idService: IdService) {
		this.id = this.idService.generate();
	}

	generateInitials(name) {
		const fullName = name.split(" ").map(val => val.substring(0, 1));
		return fullName.join("");
	}

	linkClicked(article) {
		this.ctaLinkClicked.emit(article);
	}

	idGen(i) {
		return this.id + "MenuItem" + i;
	}
}
